import React from "react";
import axios from "axios";
import { useState, useEffect, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Calendar } from "primereact/calendar";
import { MultiSelect } from "primereact/multiselect";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const apiUrl = process.env.REACT_APP_API_URL;

export const AjoutLocation = ({
  setAfficherAjoutLoc,
  afficherAjoutLoc,
  setIdInfoLoc,
}) => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("info");
  const [selectedValue, setSelectedValue] = useState([]);
  const [stockageOptions, setStockageOptions] = useState([]);
  const [idClient, setIdClient] = useState("");
  const [idClientAlefa, setIdClientAlefa] = useState("");
  const [dateReservation, setDateReservation] = useState(null);
  const [dateEntreePrevue, setDateEntreePrevue] = useState(null);
  const [loyer, setLoyer] = useState("");
  const [noteLoc, setNoteLoc] = useState("");
  const [etatInput, setEtatInput] = useState(true);
  const [prixM3, setPrixM3] = useState(13);
  const [sumVol, setSumVol] = useState(0);
  const [nomCompl, setNomCompl] = useState("");
  const [num, setNum] = useState("");
  const [mail, setMail] = useState("");
  const [adresse, setAdresse] = useState("");
  const [idLoc, setIdloc] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoadingStockage, setIsLoadingStockage] = useState(false);

  const searchTextFieldRef = useRef(null);
  const idLocRef = useRef(null);

  useEffect(() => {
    if (searchTextFieldRef.current) {
      searchTextFieldRef.current.focus();
    }
  }, []);

  useEffect(() => {
    recStockage();
  }, []);

  //  Correction : utilisation de useRef pour éviter la boucle infinie
  useEffect(() => {
    idLocRef.current = idLoc;
  }, [idLoc]);

  //  Vérification de la location existante sans setState dans le useEffect
  useEffect(() => {
    if (idLoc !== "" && idLocRef.current !== idLoc) {
      idLocRef.current = idLoc;
      setEtatInput(true);
    }
  }, [idLoc]);

  const recStockage = () => {
    setIsLoadingStockage(true);
    axios
      .get(`${apiUrl}IHM/api/stockage.php`)
      .then((response) => {
        const data = response.data;
        if (Array.isArray(data)) {
          const options = data.map((item) => ({
            label: `${item.idStockage} - ${item.vol} m³`,
            value: item.idStockage,
            vol: parseFloat(item.vol) || 0,
          }));
          setStockageOptions(options);
        }
      })
      .catch((error) => {
        console.error("Erreur lors de la requête : ", error);
      })
      .finally(() => {
        setIsLoadingStockage(false);
      });
  };

  const showMessage = (sev, detail) => {
    setSeverity(sev);
    setMessage(detail);
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnackbar(false);
  };

 

  const searchClient = () => {
    if (!idClient.trim()) {
      showMessage("warn", "Veuillez saisir un identifiant client");
      return;
    }

    axios
      .get(`${apiUrl}IHM/api/?searchLoc=${idClient}`)
      .then((response) => {
        const data = response.data;
        if (data.length > 0) {
          const client = data[0];
          setNomCompl(client.nom);
          setIdClientAlefa(client.idClient);
          setAdresse(`${client.ville} - ${client.codePostal} - ${client.adresse}`);
          setNum(`${client.num1} - ${client.num2}`);
          setMail(`${client.mail} - ${client.mail2}`);
          setEtatInput(false);
          verifLoc(client.idClient);
        } else {
          showMessage("error", "Client non trouvé");
          resetClientFields();
        }
      })
      .catch((error) => {
        console.error("Erreur:", error);
        resetClientFields();
      });
  };

  const verifLoc = (id) => {
    axios
      .get(`${apiUrl}IHM/api/location.php?idCli=${id}`)
      .then((response) => {
        if (response.data.length > 0) {
          setIdloc(response.data[0].idLocation);
          setEtatInput(true);
        } else {
          setEtatInput(false);
        }
      })
      .catch((error) => {
        console.error("Erreur:", error);
      });
  };

  const resetClientFields = () => {
    setNomCompl("");
    setAdresse("");
    setNum("");
    setMail("");
    setEtatInput(true);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      searchClient();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selectedValue.length === 0) {
      showMessage("warn", "Veuillez sélectionner au moins un stockage");
      return;
    }

    if (!loyer) {
      showMessage("warn", "Veuillez entrer le loyer mensuel");
      return;
    }

    if (!nomCompl) {
      showMessage("warn", "Veuillez rechercher un client");
      return;
    }

    if (!dateEntreePrevue) {
      showMessage("warn", "Veuillez entrer la date d'entrée prévue");
      return;
    }

    setIsSubmitting(true);
    
    const data = {
      idClientAlefa,
      selectedId: selectedValue.map(item => item).join(','),
      dateReservation: dateReservation ? dateReservation.toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
      dateEntreePrevue: dateEntreePrevue.toISOString().split('T')[0],
      loyer: loyer,
      noteLoc: noteLoc,
      sumVol: sumVol,
    };

    try {
      const response = await axios.put(`${apiUrl}IHM/api/location.php`, data);
      
      if (response.data && response.data.lastInsertedId) {
        setIdInfoLoc(response.data.lastInsertedId);
        await rendStockOccup();
        
        showMessage("success", "Location ajoutée avec succès");
        
        setTimeout(() => {
          setAfficherAjoutLoc(false);
          window.location.reload();
        }, 1500);
      }
    } catch (error) {
      console.error("Erreur:", error);
      showMessage("error", "Erreur lors de l'ajout de la location");
    } finally {
      setIsSubmitting(false);
    }
  };

  const rendStockOccup = async () => {
    try {
      for (const id of selectedValue) {
        await axios.put(`${apiUrl}IHM/api/stockage.php?idStockage=${id}`);
      }
    } catch (error) {
      console.error("Erreur lors du marquage des stockages:", error);
    }
  };

  //  Gestion de la sélection - selectedValue est un tableau de strings (les IDs)
  const handleSelectionChange = (e) => {
    const newSelected = e.value || [];
    setSelectedValue(newSelected);
    
    //  Calcul du volume total à partir des options
    const totalVol = newSelected.reduce((acc, id) => {
      const option = stockageOptions.find(opt => opt.value === id);
      return acc + (option ? option.vol : 0);
    }, 0);
    setSumVol(totalVol);
  };

  //  Supprimer un stockage
  const removeStockage = (idToRemove) => {
    const newSelected = selectedValue.filter(id => id !== idToRemove);
    setSelectedValue(newSelected);
    
    //  Recalculer le volume total
    const totalVol = newSelected.reduce((acc, id) => {
      const option = stockageOptions.find(opt => opt.value === id);
      return acc + (option ? option.vol : 0);
    }, 0);
    setSumVol(totalVol);
  };

  const handleValeurPaieChange = (e) => {
    const inputValue = e.target.value;
    if (/^[+]?\d*\.?\d*$/.test(inputValue) || inputValue === "") {
      setLoyer(inputValue);
    }
  };

  const handlePrixM3Change = (e) => {
    const inputValue = e.target.value;
    if (/^[+]?\d*\.?\d*$/.test(inputValue) || inputValue === "") {
      setPrixM3(inputValue);
    }
  };

  // Calcul du loyer estimé : volume total * prix au m³
  const loyerEstime = (sumVol * (parseFloat(prixM3) || 0)).toFixed(2);

  const header = (
    <div className="flex justify-content-between align-items-center w-full">
      <span className="font-semibold text-lg">Enregistrer une nouvelle location</span>
    </div>
  );

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        message={message}
       
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleCloseSnackbar}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />

      <Dialog
        blockScroll
        visible={true}
        header={header}
        className="custom-dialog"
        style={{ width: "60vw", maxWidth: "800px" }}
        modal
        onHide={() => setAfficherAjoutLoc(false)}
        breakpoints={{ "960px": "90vw", "640px": "95vw" }}
      >
        <div className="p-3">
          {/* Section 1 - Recherche client */}
          <div className="grid">
            <div className="col-12">
              <div
                style={{
                  background: "#f3f4f6",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  marginBottom: "10px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <span
                  style={{
                    background: "#374151",
                    color: "white",
                    borderRadius: "50%",
                    width: "18px",
                    height: "18px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "11px",
                    fontWeight: 700,
                  }}
                >
                  1
                </span>
                <span
                  style={{
                    fontSize: "11px",
                    fontWeight: 600,
                    color: "#374151",
                    letterSpacing: "0.05em",
                  }}
                >
                  RECHERCHE CLIENT
                </span>
              </div>
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="grid">
              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Rechercher un client
                </label>
                <div style={{ display: "flex", gap: "8px" }}>
                  <InputText
                    value={idClient}
                    onChange={(e) => {
                      setIdClient(e.target.value);
                      resetClientFields();
                    }}
                    onKeyDown={handleKeyDown}
                    placeholder="Nom / Téléphone / Email"
                    className="w-full"
                    style={{ height: "36px" }}
                    ref={searchTextFieldRef}
                  />
                  <Button
                    icon="pi pi-search"
                    onClick={searchClient}
                    style={{
                      background: "#0971b7",
                      border: "none",
                      color: "white",
                      height: "36px",
                      width: "40px",
                    }}
                  />
                </div>
              </div>

              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Client trouvé
                </label>
                <InputText
                  value={nomCompl || "Aucun client sélectionné"}
                  disabled
                  className="w-full"
                  style={{ height: "36px", background: "#f9fafb" }}
                />
              </div>
            </div>

            {/* Section 2 - Informations client */}
            <div className="grid mt-2">
              <div className="col-12">
                <div
                  style={{
                    background: "#f3f4f6",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    marginBottom: "10px",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  <span
                    style={{
                      background: "#374151",
                      color: "white",
                      borderRadius: "50%",
                      width: "18px",
                      height: "18px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "11px",
                      fontWeight: 700,
                    }}
                  >
                    2
                  </span>
                  <span
                    style={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: "#374151",
                      letterSpacing: "0.05em",
                    }}
                  >
                    INFORMATIONS CLIENT
                  </span>
                </div>
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Client
                </label>
                <InputText
                  value={`${idClientAlefa} - ${nomCompl}`}
                  disabled
                  className="w-full"
                  style={{ height: "36px", background: "#f9fafb" }}
                />
              </div>
              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Téléphone
                </label>
                <InputText
                  value={num}
                  disabled
                  className="w-full"
                  style={{ height: "36px", background: "#f9fafb" }}
                />
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Email
                </label>
                <InputText
                  value={mail}
                  disabled
                  className="w-full"
                  style={{ height: "36px", background: "#f9fafb" }}
                />
              </div>
              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Adresse
                </label>
                <InputText
                  value={adresse}
                  disabled
                  className="w-full"
                  style={{ height: "36px", background: "#f9fafb" }}
                />
              </div>
            </div>

            {/* Section 3 - Sélection stockages */}
            <div className="grid mt-2">
              <div className="col-12">
                <div
                  style={{
                    background: "#f3f4f6",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    marginBottom: "10px",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  <span
                    style={{
                      background: "#374151",
                      color: "white",
                      borderRadius: "50%",
                      width: "18px",
                      height: "18px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "11px",
                      fontWeight: 700,
                    }}
                  >
                    3
                  </span>
                  <span
                    style={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: "#374151",
                      letterSpacing: "0.05em",
                    }}
                  >
                    SÉLECTION DES STOCKAGES
                  </span>
                </div>
              </div>
            </div>

            <div className="grid">
              <div className="col-12">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Choisir les stockages
                </label>
                <MultiSelect
                  value={selectedValue}
                  options={stockageOptions}
                  onChange={handleSelectionChange}
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Sélectionner un ou plusieurs stockages"
                  className="w-full"
                  disabled={etatInput || isLoadingStockage}
                  filter={false}
                  style={{ height: "36px" }}
                />
              </div>
            </div>

            {/* AFFICHAGE DES CHIPS */}
            {selectedValue.length > 0 && (
              <div className="grid">
                <div className="col-12">
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "6px",
                      padding: "8px 0",
                      marginTop: "8px",
                    }}
                  >
                    {selectedValue.map((id) => {
                      const option = stockageOptions.find(opt => opt.value === id);
                      const label = option ? option.label : id;
                      return (
                        <div
                          key={id}
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            background: "#dbeafe",
                            color: "#1d4ed8",
                            fontWeight: 500,
                            fontSize: "13px",
                            padding: "4px 12px",
                            borderRadius: "16px",
                            border: "1px solid #bfdbfe",
                          }}
                        >
                          <span>{label}</span>
                          <button
                            type="button"
                            onClick={() => removeStockage(id)}
                            style={{
                              border: "none",
                              background: "transparent",
                              cursor: "pointer",
                              padding: 0,
                              margin: 0,
                              fontSize: "14px",
                              color: "#1d4ed8",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              lineHeight: 1,
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.color = "#dc2626";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.color = "#1d4ed8";
                            }}
                          >
                            ✕
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}

            <div className="grid">
              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Loyer mensuel (€)
                </label>
                <InputText
                  value={loyer}
                  onChange={handleValeurPaieChange}
                  className="w-full"
                  style={{ height: "36px" }}
                  disabled={etatInput}
                />
              </div>
              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Prix au m³
                </label>
                <InputText
                  value={prixM3}
                  onChange={handlePrixM3Change}
                  className="w-full"
                  style={{ height: "36px" }}
                  disabled={etatInput}
                />
              </div>
            </div>

            <div className="grid">
              <div className="col-12">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Date d'entrée prévue
                </label>
                <Calendar
                  value={dateEntreePrevue}
                  onChange={(e) => setDateEntreePrevue(e.value)}
                  dateFormat="dd/mm/yy"
                  className="w-full"
                  disabled={etatInput}
                  showIcon={false}
                  style={{ height: "36px" }}
                />
              </div>
              {/* <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Date de réservation
                </label>
                <Calendar
                  value={dateReservation}
                  onChange={(e) => setDateReservation(e.value)}
                  dateFormat="dd/mm/yy"
                  className="w-full"
                  disabled={etatInput}
                  showIcon={false}
                  style={{ height: "36px" }}
                />
              </div> */}
            </div>

            <div className="grid">
              <div className="col-12">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Note
                </label>
                <InputTextarea
                  value={noteLoc}
                  onChange={(e) => setNoteLoc(e.target.value)}
                  rows={3}
                  className="w-full"
                  style={{ resize: "vertical" }}
                  disabled={etatInput}
                />
              </div>
            </div>


            {/* Récapitulatif */}
            <div className="grid mt-2">
              <div className="col-12">
                <div
                  style={{
                    background: "#f5f3eb",
                    borderRadius: "5px",
                    padding: "8px 12px",
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: "14px", fontWeight: 600 }}>
                    <span>Récapitulatif</span>
                    <span>{selectedValue.length} box sélectionné(s)</span>
                  </div>
                  {selectedValue.map((id) => {
                    const option = stockageOptions.find(opt => opt.value === id);
                    const label = option ? option.label : id;
                    const vol = option ? option.vol : 0;
                    return (
                      <div key={id} style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: "13px", color: "#6b7280" }}>
                        <span>{label}</span>
                        <span>{vol.toFixed(2)} m³</span>
                      </div>
                    );
                  })}
                  <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderTop: "1px solid #d1d5db", marginTop: "4px", fontWeight: 600 }}>
                    <span>Volume total</span>
                    <span>{sumVol.toFixed(2)} m³</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", fontWeight: 700, fontSize: "15px", color: "#1d4ed8" }}>
                    <span>Loyer estimé</span>
                    <span>{loyerEstime} €</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Bouton ajouter */}
            <div className="grid mt-3">
              <div className="col-12">
                <Button
                  label="Ajouter la location"
                  icon="pi pi-check"
                  className="w-full"
                  type="submit"
                  disabled={isSubmitting || etatInput}
                  style={{
                    background: "#0971b7",
                    border: "none",
                    padding: "0.75rem",
                    borderRadius: "6px",
                    fontSize: "14px",
                    fontWeight: 500,
                    justifyContent: "center",
                    gap: "8px",
                    color: "white",
                  }}
                />
              </div>
            </div>
          </form>
        </div>
      </Dialog>
    </>
  );
};